import React, { useMemo } from 'react'
import get from 'lodash/get'
import { useListQuery } from 'components/graphql'

const remoteOtionsHOC = Component => (props) => {
	const { remoteOptions: { query, startFromId, variables, sort, fetchPolicy, additionalOptions = [], modifyOptions, ref, ...rest }, value, fieldState, simpleValue, noForm, valueField = 'value' } = props
	const selectValue = noForm ? value : fieldState.value
	const getModifiedOptions = (options) => {
		if(typeof modifyOptions !== 'function') {
			return options
		}
		const modified = modifyOptions(options)
		return Array.isArray(modified) ? modified : options
	}

	const { limit } = get(variables, 'params', {})

	const result = useListQuery(query, {
		...startFromId !== false && { startFromId: simpleValue ? selectValue : startFromId },
		clearStartFromId: true,
		fetchPolicy: fetchPolicy || 'cache-first',
		variables: variables || { params: {} },
		...sort && { sort },
		limit,
		...rest
	})
	const selectOptions = [...additionalOptions, ...getModifiedOptions(result.data)]

	const selectedOptionValue = simpleValue ? selectValue : get(selectValue, valueField)
	const isValueInOptions = useMemo(() => selectedOptionValue && result.data.some(opt =>
		opt[valueField] && opt[valueField].toString() === selectedOptionValue.toString()
	), [result.data, valueField, selectedOptionValue])

	if(ref && typeof ref === 'object') {
		ref.current = result
	}

	return(
		<Component
			key={isValueInOptions}
			{...props}
			options={selectOptions}
			remoteResult={result}
			error={result.error}
		/>
	)
}

export default remoteOtionsHOC
